import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateActionItemsMutationVariables = Types.Exact<{
  data: Types.CreateActionItemsInput;
}>;


export type CreateActionItemsMutation = { createActionItems: { actionItems?: Array<{ id: string }> | null } };


export const CreateActionItemsDocument = /*#__PURE__*/ gql`
    mutation createActionItems($data: CreateActionItemsInput!) {
  createActionItems(data: $data) {
    actionItems {
      id
    }
  }
}
    `;

export function useCreateActionItemsMutation() {
  return Urql.useMutation<CreateActionItemsMutation, CreateActionItemsMutationVariables>(CreateActionItemsDocument);
};